import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { FormWrapper, Label, Select, Button, Input } from './shared_form_styles';
import { Wrapper, Header, NameWrapper, Row, Column, ButtonSection, InfoLabel, InputName, NavButton } from './shared_details_form_styles';
import { addSubject, updateSubject } from '../actions/subjectActions';
import styled from 'styled-components';

const NameInput = styled(InputName)`
    margin-right: 20px;
`;
const RowOnCreateStudent = styled(Row)`
@media (max-width:600px) {
    flex-direction: column;
} 
`;

const ColumnOnCreateStudent = styled(Column)`
@media (max-width:600px) {
    width:90%;
} 
`;


export const Subject = ({ subject }) => {

  const [name, setName] = useState("");
  const [isMandatory, setisMandatory] = useState(false);
  const [abbreviation, setAbbreviation] = useState("");


  const dispatch = useDispatch();

  useEffect(() => {
    if (subject) {
      setName(subject.name);
      setisMandatory(subject.isMandatory);
      setAbbreviation(subject.abbreviation);
    }
  }, [])
  const handleSave = async () => {
    let input = {};

    if (subject) {
      input = { ...input, subjectId: subject._id}
      if (isMandatory != subject.isMandatory) {
        input = { ...input, isMandatory, abbreviation }
      }
      if (name != subject.name) {
        input = { ...input, name }
      }
      if (abbreviation != subject.abbreviation) {
        input = { ...input, abbreviation, prevAbbreviation: subject.abbreviation }
      }
      //is edition
      
      dispatch(updateSubject(input));

    } else {
      //is creation
 
      input = { name, abbreviation, isMandatory };
      dispatch(addSubject(input));

    }

  };

  return (
    <Wrapper>

      <Header>
        <NameWrapper>
          <NameInput
            type="text"
            name="name"
            placeholder='Name'
            value={name}
            onChange={(e) => { setName(e.target.value) }}

          />
        </NameWrapper>

      </Header>
      <Row>
        <ColumnOnCreateStudent>
          <Label>
            Code:
            <Input
              type="text"
              name="abbreviation"
              placeholder='Codigo'
              value={abbreviation}
              onChange={(e) => { setAbbreviation(e.target.value) }}

            />
          </Label>
          <Label style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            Mandatory:
            <Input
              style={{ width: '20px' }}
              type="checkbox"
              name="isMandatory"
              checked={isMandatory}
              onChange={(e) => { setisMandatory(e.target.checked) }}
            />
          </Label>
        </ColumnOnCreateStudent>
      </Row>
      {name != '' && abbreviation!=''&& <Button style={{ width: '50%' }} onClick={()=>handleSave()}>Save</Button>}
  

    </Wrapper>
  );
};


export default Subject;
